export const VOICE_TYPE = {
  GOOGLE: "google",
};

export const GOOGLE_VOICES_DOCS_URL =
  "https://cloud.google.com/text-to-speech/docs/voices";

export const VOICE_TYPE_OPTIONS = [
  { label: "google", value: VOICE_TYPE.GOOGLE },
];

export const VOICE_GENDER_OPTIONS = [
  { label: "MALE", value: "MALE" },
  { label: "FEMALE", value: "FEMALE" },
  { label: "NEUTRAL", value: "NEUTRAL" },
];

export const getGoogleVoice = (language) =>
  language?.voices?.find((voice) => voice.type === VOICE_TYPE.GOOGLE);

export const createEmptyVoice = () => ({
  type: VOICE_TYPE.GOOGLE,
  languageCode: "",
  name: "",
  ssmlGender: "MALE",
  audioEncoding: "MP3",
});
